// 主要是使用策略模式（面向过程）收敛 游客登录及后续可能出现的情况
import { getItem, setItem, removeItem } from '@/utils/storage-main.js'
import loginSDK from '@/utils/base'
import { handleFinalJump, handleScheme } from '@/utils/login.js'
import { handleJump } from '@/utils/guest.js'
import api from '@/http/api'
import { param2Obj, genfinalUrl, validURl, successJump } from '@/utils/utils.js'
import router from '@/router'
import store from '@/store'
import handleSaveAndJump from '@/utils/saveLogin.js'
import { getBusinessType } from '@/constant'
const AiaConfig = getBusinessType()
const AIA_ID = AiaConfig.id || 'aia'
// 处理获取openID 相关内容
function handleGetOpenId() {
  const openId = getItem('open_id')
  if (!openId) {
    const { code } = param2Obj(window.location.href)
    if (!code) {
      const search = window.location.search && window.location.search.slice(1)
      const endQuery = search ? `&${search}` : ''
      const redirectUriMobile = encodeURIComponent(
        `${process.env.VUE_APP_REDIRECT_URI}/?enter=login${endQuery}`
      )
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${process.env.VUE_APP_MOBIE_APPID}&redirect_uri=${redirectUriMobile}&response_type=code&scope=snsapi_userinfo&state=#wechat_redirect`
      return false
    }
    return code
  }
}
// 保存openID
const saveOpenId = async (code) => {
  const codeinfo = {
    mode: 'wechat_mobile',
    code: code,
  }
  try {
    const { data } = await api.login.GetSilentCode(codeinfo)
    return data
  } catch (error) {
    console.log(error)
  }
}

// 微信静默授权后直接返回
function hanleBackToWechat(url) {
  removeItem('tag')
  window.location.href = `${url}?openid=${getItem('open_id')}`
  return
}

// 微信登录openid
const handleMobileWechat = async (name, redirect_url, callback) => {
  if (getItem('open_id')) {
    callback()
  } else {
    // 被动获取openid
    const code = handleGetOpenId()
    if (code) {
      const data = await saveOpenId(code)
      const { open_id } = data
      if (open_id) {
        setItem('open_id', open_id)
        if (name && name === 'openid') {
          hanleBackToWechat(redirect_url)
        } else {
          callback()
        }
      }
    }
  }
}
// 普通三方登录获取authCode并跳转
const thirdBaseLogin = async (params, gi_guest) => {
  try {
    const authData = await store.dispatch('GetAuthCode', params, gi_guest)
    handleSaveAndJump(authData.data)
  } catch (error) {
    throw error
  }
}
// 游客三方登录
const handleThirdLogin = async (params, gi_guest) => {
  const data = await store.dispatch('BindUser', params, gi_guest)
  setItem('thirdLoginWithBinded', 'binded')
  handleSaveAndJump(data.data)
}

// 处理游客业务
const handleGuest = () => {
  setItem('isguest', 'guest')
  // 移动端需要存储url中的token
  const { isguest, redirect_url } = param2Obj(window.location.href)
  // 存储游客token
  if (isguest) {
    setItem('fromMobile', 'yes')
    setItem('Authorization', isguest)
    setItem('guestUrl', redirect_url)
  }
}

// 处理hicool登录逻辑
const handleHiCool = async () => {
  const urlParams = new URLSearchParams(window.location.search)
  const hitoken = urlParams.get('hitoken')
  const redirectUrl = urlParams.get('redirect_url')
  if (hitoken) {
    // 因为不同于auth2所以需要主动触发三方登录的逻辑
    try {
      await thirdLoginHanlder(
        '',
        { mode: 'hicool', code: hitoken, call_back_url: redirectUrl },
        ''
      )
    } catch (error) {
      window.location.href = `${process.env.VUE_APP_HICOLL}`
    }
  }
}

const aiaLogin = async (source) => {
  if (source !== 'aia-hr') {
    const res = await store.dispatch('getUserExtraInfo', {
      source: 'aia',
    })
    const { prop } = res?.data || {}
  
    if (!prop?.aia_extra_phone) {
      const query = { ...router.currentRoute.query }
  
      router.replace({
        path: '/aia-phone',
        query,
      })
      return;
    }
  }
  
  const { redirect_url } = param2Obj(window.location.href)
  // 白名单校验
  if (redirect_url && validURl(redirect_url)) {
    const successUrl = genfinalUrl(redirect_url)
    const extraParams = getItem('extraParams')
    successJump(`${successUrl}${extraParams}`)
    return
  }
  successJump()
}

// 处理 Aia 自动登录逻辑
const handleAia = async () => {
  const path = location.pathname
  const agentpath = 'aia-agent'

  if (loginSDK.getCurrentToken() && !path.includes(agentpath)) {
    try {
      // 通过接口判断是否退出登录的逻辑
      await store.dispatch('CheckProtocal')
    } catch (error) {
      // /user/bind/phone(有效token进行登录) || /login(需要重新登录)
      const aiaLogined = getItem('aiaLogined')
      
      if (error?.data?.scheme == '/user/bind/phone' && aiaLogined == 'true') {
        // defaultLogin()
        aiaLogin()
      } else {
        setItem('aiaLogined', false)
      }
    }
  }
}

// 处理 aia 点击登录逻辑
const handleAiaLogin = async (source) => {
  const aiaLogined = getItem('aiaLogined')
  if (aiaLogined == 'true') {
    // defaultLogin()
    aiaLogin(source)
  }
}

// 有token需要先校验token是否有效，有效就直接跳走
// 还需要处理是否需要绑定手机号
// 没有token就走正常的登录逻辑
const loginAction = async () => {
  if (loginSDK.getCurrentToken()) {
    try {
      await store.dispatch('CheckProtocal')
      await store.dispatch('getUserInfo')
      if (
        router.currentRoute.name !== 'personalInfo' &&
        !getItem('isguest') &&
        getBusinessType().isAutoLogin
      ) {
        handleFinalJump()
      }
    } catch (error) {
      // 处理伪协议相关内容
      handleScheme(error)
    }
  }
}
// 游客模式所需逻辑初始化
const handleVisitorLogin = () => {
  removeItem('isguest')
  let successUrl = ''
  if (getItem('thirdLoginWithBinded')) {
    removeItem('thirdLoginWithBinded')
    successUrl = genfinalUrl(getItem('guestUrl'))
    successJump(successUrl)
  } else {
    // 用来跳转
    if (getItem('fromMobile')) {
      removeItem('fromMobile')
      const { redirect_url } = param2Obj(window.location.href)
      successUrl = genfinalUrl(redirect_url)
      successJump(successUrl)
    } else {
      handleJump()
    }
  }
}

// 三方应用换取code的逻辑
const handleCodeLogin = async () => {
  const { redirect_url } = param2Obj(window.location.href)
  if (redirect_url && validURl(redirect_url)) {
    const successUrl = `${redirect_url}?code=${getItem('sso_resp')}`
    successJump(successUrl)
  } else {
    // 无效的url
  }
}
const defaultLogin = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const redirectUrl = urlParams.get('redirect_url')

  // 白名单校验
  if (redirectUrl && validURl(redirectUrl)) {
    const successUrl = genfinalUrl(redirectUrl)
    const extraParams = getItem('extraParams')
    
    successJump(`${successUrl}${extraParams}`)
    return
  }
  successJump()
}

const handleRegister = async (params) => {
  return await store.dispatch('BindUser', params)
}

// 枚举：不同类型的业务逻辑
// guest | refresh_token | openid | hitoken
const GOTIN_STRATEGY = {
  guest: () => handleGuest(),
  openid: (name, redirect_url, callback) =>
    handleMobileWechat(name, redirect_url, callback),
  hitoken: () => handleHiCool(),
  aia: () => handleAia(),
  'aia-hr': () => handleAia(),
}

// 枚举：登录
// guest | gotin | defalut
const GOTIN_TYPE_STRATEGY = {
  guest: () => handleVisitorLogin(),
  expo: () => handleCodeLogin(),
  cocafe: () => handleCodeLogin(),
  aia: () => handleAiaLogin(),
  'aia-hr': () => handleAiaLogin('aia-hr'),
}

// 枚举：注册
// guest | defalut
const GOTIN_REGISTER_STRATEGY = {
  guest: (params) => handleRegister(params),
}

// 枚举: 三方登录
// 游客 | defalut
const GOTIN_THIRD_STRATEGY = {
  guest: (params, gi_guest) => handleThirdLogin(params, gi_guest),
}
// 枚举: 移动端特殊行为
// openid |
const GOTIN_THIRD_TYPE = {
  openid: (name, redirect_url, callback) =>
    handleMobileWechat(name, redirect_url, callback),
}

// 行为：标记不同业务逻辑并处理
const getBusinessChannel = (name) => {
  // 如果本次访问的项目和上次存token时访问的项目不一致，就删除本地token，让用户重新登录，防止串数据导致的各种bug
  if (getItem('business') !== name) {
    removeItem('Authorization')
  }
  // 将对应的name存储到全局，以便后续的业务处理
  setItem('business', name)
  return GOTIN_STRATEGY[name]?.() ?? loginAction()
}

// 行为：登录
const handleLogin = (name) => {
  return GOTIN_TYPE_STRATEGY[name]?.() ?? defaultLogin()
}

// 行为：注册
const handleBusinessRegiser = (name, params, callback) => {
  return GOTIN_REGISTER_STRATEGY[name]?.(params) ?? callback(params)
}

// 行为：三方登录/注册
const thirdLoginHanlder = (name, params, gi_guest) => {
  return (
    GOTIN_THIRD_STRATEGY[name]?.(params, gi_guest) ??
    thirdBaseLogin(params, gi_guest)
  )
}

// 行为: 微信环境
// openid |
const handleThirdParams = (name, redirect_url, next) => {
  return (
    GOTIN_THIRD_TYPE[name]?.(name, redirect_url, next) ??
    handleMobileWechat(name, redirect_url, next)
  )
}

export {
  getBusinessChannel,
  handleLogin,
  handleThirdParams,
  thirdLoginHanlder,
  handleBusinessRegiser,
}
